// extracted by mini-css-extract-plugin
export var box = "_4z-1";
export var checkboxRow = "_4z-8";
export var checked = "_4z-2";
export var descriptionSpacer = "_4z-a";
export var disabled = "_4z-3";
export var icon = "_4z-6";
export var input = "_4z-0";
export var labelSpacer = "_4z-9";
export var medium = "_4z-5";
export var small = "_4z-4";
export var text = "_4z-7";